"use client";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../components/navbar";
import Footer from "../../../components/footer";
import Table from "../../../components/Table";
import Button from "../../../components/Button";
import Pagination from "../../../components/Pagination";
import styles from "../css/dashboard.module.css";
import { getBranches as apiGetBranches, updateBranch as apiUpdateBranch } from "../../../api/branchManagement]/branchApi";

export default function BranchTableView() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;

  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toggling, setToggling] = useState({}); 

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        setLoading(true);
        const data = await apiGetBranches();
        const normalized = Array.isArray(data)
          ? data.map((b) => ({ ...b, isactive: !!b.isactive }))
          : [];
        setBranches(normalized);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchBranches();
  }, []);

  // Calculate paginated data
  const totalPages = Math.ceil(branches.length / rowsPerPage);
  const paginatedData = branches.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  // Table columns
  const columns = [
    { header: "Branch Code", accessor: "branchcode" },
    { header: "Branch Name", accessor: "branchname" },
    {
      header: "Action",
      accessor: "action",
      render: (_, row) => (
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <Button onClick={() => handleEdit(row)} variant="primary">Edit</Button>
          <Button
            onClick={() => handleToggleDisable(row)}
            variant={row.isactive ? "secondary" : "approve"}
            disabled={!!toggling[row.branchcode]}
          >
            {row.isactive ? "Disable" : "Enable"}
          </Button>
        </div>
      ),
    },
  ];

  // Handlers
  const handleEdit = (row) => {
    navigate("/edit-branch", { state: { branchcode: row.branchcode } });
  };

  const handleToggleDisable = async (row) => {
    try {
      setToggling((prev) => ({ ...prev, [row.branchcode]: true }));
      await apiUpdateBranch(row.branchcode, { isactive: !row.isactive });
      const data = await apiGetBranches();
      const normalized = Array.isArray(data)
        ? data.map((b) => ({ ...b, isactive: !!b.isactive }))
        : [];
      setBranches(normalized);
    } catch (e) {
      console.error(e);
    } finally {
      setToggling((prev) => ({ ...prev, [row.branchcode]: false }));
    }
  };

  const handleAddBranch = () => {
    navigate("/add-branch");
  };

  return (
    <div className={styles.app}>
      <div className={styles.mainContainer}>
        <Navbar />

        <main className={styles.content}>
          <div className={styles.tableContainer}>
            <div className={styles.tableActions} style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button onClick={handleAddBranch} variant="primary">Add Branch</Button>
            </div>
            <Table columns={columns} data={loading ? [] : paginatedData} />
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div style={{ marginTop: "1rem", display: "flex", justifyContent: "center" }}>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          )}
        </main>

        <div className={styles.footerWrapper}>
          <Footer />
        </div>
      </div>
    </div>
  );
}